module.exports = __webpack_public_path__ + "static/media/activation.f7aa09b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/activation.svg
// module id = 1332
// module chunks = 0